import React from 'react';
import { HiExclamationCircle } from 'react-icons/hi';

function FormError({ error }) {
    if (!error) return null;

    let errorData = null;

    if (error.response?.data) {
        errorData = error.response.data;
    }
    else if (error.request) {
        errorData = { non_field_errors: ['No response from server. Please check your connection.'] };
    }
    else if (typeof error === 'string') {
        errorData = { non_field_errors: [error] };
    }
    else if (error.message) {
        errorData = { non_field_errors: [error.message] };
    }
    else if (typeof error === 'object' && error !== null) {
        errorData = error;
    }
    else {
        errorData = { non_field_errors: ['An unexpected error occurred'] };
    }

    const errorEntries = Object.entries(errorData).filter(([key, value]) => {
        return typeof value === 'string' || Array.isArray(value);
    });

    if (errorEntries.length === 0) {
        return (
            <div className="alert alert-error rounded-md mb-4">
                <HiExclamationCircle className="h-5 w-5" />
                <span>An error occurred</span>
            </div>
        );
    }

    if (errorEntries.length === 1) {
        const [field, messages] = errorEntries[0];
        const errorMessages = Array.isArray(messages) ? messages : [messages];

        if (errorMessages.length === 1 && (field === 'non_field_errors' || field === 'detail')) {
            return (
                <div className="alert alert-error rounded-md mb-4">
                    <HiExclamationCircle className="h-5 w-5" />
                    <span>{errorMessages[0]}</span>
                </div>
            );
        }
    }

    return (
        <div className="bg-red-50 text-red-700 rounded-xl text-sm mb-4 p-3">
            <div className="flex flex-col w-full space-y-2">
                <div className="flex items-center space-x-2">
                    <HiExclamationCircle className="h-9 w-9" />
                    <span className="font-semibold">Please fix the following errors:</span>
                </div>
                <ul className="list-disc list-inside space-y-1 ml-7">
                    {errorEntries.map(([field, messages]) => {

                        const fieldName = field === 'non_field_errors' || field === 'detail'
                            ? 'Error'
                            : field.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());

                    
                        const errorMessages = Array.isArray(messages) ? messages : [messages];

                        return errorMessages.map((msg, idx) => (
                            <li key={`${field}-${idx}`} className="text-sm">
                                <span className="font-medium">{fieldName}:</span> {msg}
                            </li>
                        ));
                    })}
                </ul>
            </div>
        </div>
    );
}

export default FormError;